<template>
  <div class="" v-loader.opacity.tab="loading">
    <div class="alert" :class="alert.class" role="alert" v-if="alert.message || logomsg.message">
      <span v-html="alert.message"></span>
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = null"></button>
    </div>

    <vee-form v-slot="{ handleSubmit, setFieldValue, setFieldTouched, validate, resetForm, meta }" as="div">
      <form @submit.prevent.stop="handleSubmit(saveOrUpdate)">

        <ClinicFormData
          ref="clinicFormDataRef"
          v-if="clinic.id"
          :clinic="clinic"
          :features="session.features"
          :disabled="disabled"
          @option-selected="setConfiguration"
          @security-changed="securityChanged"
          @do-update-feature="updateFeatureFlag"
          :setFieldValue="setFieldValue"
          :setFieldTouched="setFieldTouched"
          :validateForm="validate"
          :resetVeeForm="resetForm"
          :formMeta="meta">
        </ClinicFormData>

        <div class="action-bar">
          <button class="btn btn-success" type="submit" name="button" data-test="btnUpdate" v-if="canSaveData">
            <span>{{ $t('updateAction') }}</span>
          </button>
          <button class="btn btn-secondary" type="button" name="button" v-if="canSaveData" @click="discardChanges">
            <span>{{ $t('clinic.cancel') }}</span>
          </button>
          <button class="btn btn-secondary" type="button" v-if="!isSpecialist  && isCurrentClinic" name="button" data-test="btnOpenModalLogo" @click="openChangeLogoOffcanvas">
            <span>{{ $t('clinic.changeLogoSmall') }}</span>
          </button>
          <button class="btn btn-secondary" type="button" v-if="canChangeOwner" name="button" data-test="btnOpenModalLogo" @click="openClinicUpdateOwnerffcanvas">
            <span>{{ $t('clinic.changeOwnerBtn') }}</span>
          </button>
        </div>
      </form>
    </vee-form>

    <teleport to="body">
      <BaseCropperOffcanvas :offcanvas_id="'offcanvasCropper'" ref="offcanvasCropper"/>
      <ClinicUpdateOwnerOffcanvas :offcanvas_id="'ClinicUpdateOwnerOffcanvas'" ref="clinicUpdateOwnerOffcanvas"/>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { useUserStore } from '@/store/user'
import ClinicFormData from '../ClinicFormData.vue'
import ClinicUpdateOwnerOffcanvas from './ClinicUpdateOwnerOffcanvas.vue'

export default {
  name: 'ClinicInfoTab',
  props: ['clinic_id', 'logomsg'],
  components: {
    ClinicFormData,
    ClinicUpdateOwnerOffcanvas
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    isSpecialist: null,
    statusOptions: [],
    statusSelected: 'open',
    clinic: {
      name: '',
      fantasyName: '',
      document: '',
      email: '',
      telephone1: '',
      telephone2: '',
      address: '',
      addressNumber: '',
      district: '',
      city: '',
      locale: '',
      state: '',
      passwordExpirationDays: 0,
    },
    clinicLogo: null,
    disabled: true,
    isCurrentClinic: false,
    isClinicMounted: false,
    systemConfiguration: {},
    hasFormChanged: false,
    changedFormItems: [],
    initialForm: {},
    canChangeOwner: false,
  }),
  computed: {
    canSaveData() {
      return this.hasFormChanged && !this.isSpecialist && this.isCurrentClinic
    }
  },
  watch: {
    logomsg: function(newVal) {
      if (newVal) {
        this.alert.message = newVal.message
        this.alert.class = newVal.class
        this.fetchData();
      } else {
        this.alert.message = null
      }
    },
    clinic_id: {
      immediate: true,
      handler: function (clinic_id) {
        if (clinic_id) {
          this.fetchData()

          this.$nextTick(() => {
            this.hasFormChanged = false
            this.changedFormItems = []
          })
        }
    }, deep: true },
    clinic: {
      immediate: true,
      handler: function(newValue) {
        if (newValue && newValue.id) {
          this.$nextTick(() => {
            if (this.$refs.clinicFormDataRef && this.$refs.clinicFormDataRef.setVeeValidateFields) {
              this.$refs.clinicFormDataRef.setVeeValidateFields()
            }
          });
        }

        this.checkFormChange(newValue, 'clinic')
    }, deep: true},
  },
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo

    this.isCurrentClinic = this.clinic_id === this.session.currentClinic.id
    this.isSpecialist = this.session.isSpecialist
    this.canChangeOwner = (this.session.permissions.includes('owner') || this.session.permissions.includes('admin')) && this.isCurrentClinic

    this.statusOptions = [
      {value: 'open', name: this.$i18n.t('open')},
      {value: 'closed', name: this.$i18n.t('closed')}
    ];

    // this.fetchData();

    this.isClinicMounted = true
  },
  methods: {
    checkFormChange(value, obj) {
      if (!this.initialForm || !this.initialForm[obj])
        return

      let hasObj = this.changedFormItems.includes(obj)
      if (JSON.stringify(value) === JSON.stringify(this.initialForm[obj])) {
        if (hasObj) {
          let index = this.changedFormItems.indexOf(obj)
          this.changedFormItems.splice(index, 1)
        }

        if (this.changedFormItems.length > 0)
          return

        this.hasFormChanged = false
      } else {
        if (!hasObj)
          this.changedFormItems.push(obj)

        this.hasFormChanged = true
      }
    },
    discardChanges() {
      this.clinic = _.cloneDeep(this.initialForm.clinic);
      this.changedFormItems = [];
      this.hasFormChanged = false;
      this.$message.popup(this, 'general.changesDiscarded', 'operationSuccess', 'info')

      if (this.resetVeeForm)
        this.resetVeeForm()

      this.$nextTick(() => {
        this.$refs.clinicFormDataRef.setLocaleConfig()
      });
    },
    async fetchData() {
      this.initialForm = {}

      let params = {
        id: this.clinic_id
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.getClinic(params);
        this.clinic = response.clinic
        this.clinicLogo = response.clinicLogo

        const formWrap = {
          clinic: this.clinic,
        }

        this.initialForm = _.cloneDeep(formWrap)

        this.$nextTick(() => {
          this.hasFormChanged = false
          this.changedFormItems = []
        })

        this.systemConfiguration = this.$clinicService.getSystemConfiguration(this.clinic)
      } catch (err) {
        this.$message.popup(this, `Error: ${err.message}`, 'operationFail', 'error')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
    async saveOrUpdate() {
      let params = {
        clinic: {
          ...this.clinic,
          email: this.clinic.email.toLowerCase()
        }
      }

      params.clinic.id = this.clinic.id

      if (this.clinic.parent)
        params.clinic.parent = this.clinic.parent.id

      this.loading = true
      NProgress.start()

      try {
        let response = await this.$clinicService.updateClinic(params)
        if (response.result.locale)
          this.$i18n.locale = response.result.locale

        this.initialForm.clinic = _.cloneDeep(this.clinic);

        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')
        this.disabled = true
        this.hasFormChanged = false

        if (this.resetVeeForm)
          this.resetVeeForm()

        this.$nextTick(async () => {
          if (this.$refs.clinicFormDataRef && this.$refs.clinicFormDataRef.setVeeValidateFields) {
            this.$refs.clinicFormDataRef.setVeeValidateFields()
          }

          await this.$authService.refreshSession(this)
        });
      } catch (e) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.updatedError', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
    setConfiguration(val) {
      this.clinic.country = val.country
      this.clinic.mandatoryDocument = val.mandatoryDocument
      this.clinic.locale = val.locale
      this.clinic.shareCcEmails = val.shareCcEmails
    },
    securityChanged(value) {
      console.log("securityChanged()", value)

      // TODO move to clinic-service
      let systemConfiguration = this.clinic.systemConfiguration ? this.clinic.systemConfiguration : {}
      let security = systemConfiguration.security ? systemConfiguration.security : {}
      security.mfaMode = value.mfaMode
      this.clinic.systemConfiguration.security = security
    },
    async openChangeLogoOffcanvas() {
      this.alert.message = null;

      this.clinicLogo ? this.clinicLogo : '@/assets/images/phelcom/profile_img.png'

      const ok = await this.$refs.offcanvasCropper.show({
        title: this.$i18n.t('clinic.changeLogo'),
        imgSrc: this.clinicLogo,
        okButton: this.$i18n.t('save'),
        okButtonClass: 'btn-primary',
        cancelButton: this.$i18n.t('cancel'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        let canvas = ok.canvas
        canvas.toBlob(blob => {
          var formData = new FormData()
          formData.append('data', blob)
          this.doSaveLogo(formData)
        }, 'image/png')
      }
    },
    doSaveLogo: async function(value) {
      let params = {
        id: this.clinic_id,
        logo: value.get('data')
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.uploadLogo(params)
        this.clinicLogo = response.clinicLogo
        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
    async updateFeatureFlag(params) {
      this.loading = true
      NProgress.start()

      try {
        const response = await this.$clinicService.updateFeatureFlag(params)

        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')

        await this.$authService.refreshSession(this)
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
    async openClinicUpdateOwnerffcanvas() {
      const ok = await this.$refs.clinicUpdateOwnerOffcanvas.show({
        title: this.$i18n.t('clinic.changeOwner'),
        text: this.$i18n.t('clinic.changeOwnerInfo'),
        okButton: this.$i18n.t('clinic.changeOwnerBtn'),
        okButtonClass: 'btn-success',
        clinicID: this.clinic.id
      })
      if (ok) {
        console.log('ok', ok);
        this.fetchData()
        // this.doUpdateClinicOwner(newEmail)
      }
    },
  }
}
</script>
